import React, { useState } from "react";

import { deleteOrganizationAPI } from "utils/organization/api";
import { readApiResponse } from "utils/api";

import Dialog, { CloseDialog } from "components/Dialog";
import Input from "components/Input";
import Button from "components/Button";

import classes from "./style.module.scss";

// Typing the name is the whole safeguard: deleting takes the shared folder, the shared code and
// upgrade libraries and the membership of everyone in it.
const DeleteOrganizationModal = ({ open, onClose, uid, orgId, name = "", memberCount = 0, onDeleted, setAlert }) => {
    const [confirmation, setConfirmation] = useState("");
    const [deleting, setDeleting] = useState(false);

    const canDelete = confirmation.trim() === name.trim() && !deleting;

    const close = () => {
        setConfirmation("");
        onClose();
    };

    const handleDelete = async () => {
        if (!canDelete) return;

        setDeleting(true);

        const { status, message } = readApiResponse(await deleteOrganizationAPI({ uid, orgId }));

        setDeleting(false);

        if (status !== 200) {
            console.error("Error deleting organization:", message);

            setAlert({
                open: true,
                message: message || "Could not delete the organization. Please try again.",
                anchorOrigin: { vertical: "top", horizontal: "center" },
                direction: "down",
                severity: "error",
            });

            return;
        }

        close();

        await onDeleted();
    };

    return (
        <Dialog open={open} closeActions={close}>
            <CloseDialog closeActions={close} />
            <div className={classes.dialog}>
                <h3>Delete {name}?</h3>
                <p>
                    This cannot be undone. The shared folder, the organization's code and upgrade libraries, and the
                    membership of {memberCount} {memberCount === 1 ? "person" : "people"} will be removed.
                </p>
                <p className={classes.safe}>
                    Models in the shared folder are not deleted. Each one goes back to the person who owns it.
                </p>
                <Input
                    label={`Type "${name}" to confirm`}
                    placeholder={name}
                    disabled={deleting}
                    input={{ value: confirmation, onChange: setConfirmation }}
                />
                <div className={classes.footer}>
                    <Button onClick={close} type="hollow" disabled={deleting}>
                        Cancel
                    </Button>
                    <Button onClick={handleDelete} type="red" disabled={!canDelete}>
                        {deleting ? "Deleting..." : "Delete Organization"}
                    </Button>
                </div>
            </div>
        </Dialog>
    );
};

export default DeleteOrganizationModal;
